module.exports = __webpack_public_path__ + "img/beez_social_erp.6650abf1.svg";